export function CreateDepth()
{
    const DepthList = {
        Background: 0,
        BackgroundAssets: 0,
        Tree: 0,
        TreeDetail:0,
        Gifts: 0,
        Tray: 0,
        OrnBack: 0,
        OrnMiddle: 0,
        OrnFront: 0,
        LightGlow: 0,
        TreeItems: 0,
        GiftsForward:0,
        ButtonBack: 0,
        Buttons: 0,
        ArrowBtn: 0,
        HitBoxTree: 0,
        DrawBlock:0
    };

    var i = 0;
    for (let x in DepthList)
    {
        DepthList[x] = i;
        i++;
    }

    //console.log(DepthList);
    return DepthList;
}